import { render, staticRenderFns } from "./InviteColleague.vue?vue&type=template&id=09844a56&scoped=true&"
import script from "./InviteColleague.vue?vue&type=script&lang=js&"
export * from "./InviteColleague.vue?vue&type=script&lang=js&"
import style0 from "./InviteColleague.vue?vue&type=style&index=0&id=09844a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09844a56",
  null
  
)

export default component.exports